import { CSSProperties, forwardRef, ReactNode, useMemo } from "react";
import TaskState from "@coworker/apprestructured/src/task-management/types/TaskState";
import styles from "./ViewerTop.module.css";
import SheetTop from "@coworker/apprestructured/src/task-management/components/SheetTop/SheetTop";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

type ViewerTopProps = {
  state: TaskState | Loading;
  children: ReactNode;
  className?: string | undefined;
  style?: CSSProperties;
  testId?: string | undefined;
};

const ViewerTop = forwardRef<HTMLDivElement, ViewerTopProps>(function ViewerTop(
  { state, children, className, style, testId },
  ref
) {
  const stateClassName = useMemo(() => {
    if (isLoading(state)) {
      return styles["pending"];
    }

    switch (state) {
      case "pending":
        return styles["pending"];
      case "completed":
        return styles["completed"];
      case "closed":
        return styles["closed"];
      default:
        return styles["pending"];
    }
  }, [state]);

  return (
    <SheetTop
      ref={ref}
      testId={testId}
      className={`${stateClassName} ${className}`}
      style={style}
    >
      {children}
    </SheetTop>
  );
});

export default ViewerTop;
